import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { playList } from "../../database/song";
import Layout from "../Layout";
import {
  RiPlayMiniFill,
  RiHeartLine,
  RiMoreFill,
  RiTimeLine,
  RiPauseMiniLine,
} from "react-icons/ri";
import {
  changePlayPause,
  changeTrack,
  changePlayPausePlayList,
} from "../../actions";
import { connect } from "react-redux";
function PlayListDescription(props) {
  const { data_id } = useParams();

  const [currentPlayList, setCurrentPlayList] = useState(null);
  const [songData, setSongData] = useState([]);

  useEffect(() => {
    getPlayListDataFromDB();
    getSongsDataFromDB();
  }, [currentPlayList, props.isPlaying]);

  const getPlayListDataFromDB = () => {
    let playListData = playList.filter((playlist) => playlist._id == data_id);
    setCurrentPlayList(playListData[0]);
  };

  const getSongsDataFromDB = () => {
    setSongData(currentPlayList != null && currentPlayList.playListSongs);
  };

  const handleOnClickPlayPause = () => {
    props.changeTrack(currentPlayList && currentPlayList.playListSongs[0]._id);
    props.changePlayPause(!props.isPlaying);
    props.changePlayPausePlayList(!props.isPlayListPlaying, data_id);
  };

  return (
    <>
      <Layout />
      <div className="pl-60  w-screen" style={{}}>
        <div
          className="w-screen h-[600px] pt-16 p-4 flex"
          style={{
            backgroundImage: `linear-gradient(${
              currentPlayList && currentPlayList.bgGradient
            })`,
          }}
        >
          <div className="h-72 flex items-center pb-10 p-4">
            <div
              className="w-56 h-56 bg-white shadow-lg mr-6"
              style={{
                boxShadow: "0 0 25px -10px black",
                borderRadius: 4,
                backgroundImage: `url(${
                  currentPlayList && currentPlayList.playListThumbnail
                })`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                borderRadius: 4,
              }}
            ></div>
            <div className="flex flex-col mt-16">
              <h1 className="text-white text-[80px] m-0 font-bold">
                {currentPlayList && currentPlayList.playListTitle}
              </h1>
            </div>
          </div>
        </div>
        <div className="w-[100%] pb-40 bg-[#0000002c] -mt-60 pt-6  pr-8 flex flex-col items-center ">
          <div className="flex items-center w-[100%] pl-8">
            <div>
              {!props.isPlaying &&
              !props.isPlayListPlaying &&
              props.playListId == data_id ? (
                <RiPauseMiniLine
                  onClick={handleOnClickPlayPause}
                  className="text-black text-6xl p-2 mr-8 bg-green-500 rounded-full  box-border  hover:p-3 transition-all ease-in-out duration-200 cursor-pointer"
                />
              ) : (
                <RiPlayMiniFill
                  onClick={handleOnClickPlayPause}
                  className="text-black text-6xl p-2 mr-8 bg-green-500 rounded-full  box-border  hover:p-3 transition-all ease-in-out duration-200 cursor-pointer"
                />
              )}
            </div>

            <RiHeartLine className="text-white text-4xl  mr-8 opacity-60 hover:opacity-100 transition-all ease-in-out duration-200 cursor-pointer" />
            <RiMoreFill className="text-white text-4xl   opacity-60 hover:opacity-100 transition-all ease-in-out duration-200 cursor-pointer" />
          </div>
          <div
            style={{
              width: "100%",
              marginTop: 30,
            }}
            className="border-b-2 border-b-neutral-600 pl-10 pr-10 p-2 ml-8 flex items-center justify-between"
          >
            <p className="text-neutral-300 text-sm opacity-70 w-screen  ">
              # <span className="ml-8">TITLE</span>
            </p>
            <RiTimeLine className="text-neutral-300 text-2xl opacity-70" />
          </div>
          <div
            style={{
              width: "100%",
              marginTop: 10,
            }}
            className="  flex flex-col items-center justify-between "
          >
            {songData &&
              songData.map((data, index) => {
                return (
                  <div
                    key={data._id}
                    onClick={() => props.changeTrack(data._id)}
                    style={{
                      width: "100%",
                    }}
                    className="flex flex-row items-center justify-between pl-10 ml-8 pr-10 p-2 mb-2 hover:bg-[#ffffff20] cursor-pointer transition-all ease-in"
                  >
                    <div className="flex items-center">
                      <p className="text-white">{index + 1}</p>
                      <p
                        className={`flex ml-8 flex-col 
                        hover:border-b-2 text-white hover:border-b-[#ffffff60] border-b-2 border-b-transparent transition-all ease-in-out`}
                      >
                        {data.title}{" "}
                        <span className="text-white opacity-60 text-sm ">
                          {data.singer}
                        </span>
                      </p>
                    </div>
                    <p className="text-white opacity-60 text-sm">03:66</p>{" "}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    songData: state.songData,
    isPlaying: state.isPlaying,
    isPlayListPlaying: state.isPlayListPlaying,
    playListId: state.playListId,
  };
};

export default connect(mapStateToProps, {
  changeTrack,
  changePlayPause,
  changePlayPausePlayList,
})(PlayListDescription);
